"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Callable = void 0;
class Callable {
    arity() {
        throw new Error('Method not implemented.');
    }
    call(interpreter, args) {
        throw new Error('Method not implemented.');
    }
}
exports.Callable = Callable;
